import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { EditableFieldBase } from '../editable-field-base';
import { InputMode } from '../text-input/text-input.component';

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss', '../editable-fields.scss'],
    standalone: false
})
export class FileUpload extends EditableFieldBase implements OnInit, OnChanges {
  @Input() accept: string;
  @Input() canDelete: boolean = true;  //  By default deleting is allowed, we can override if we want it turned off.

  //  These allow us to override for the selectFile and removeFile actions when we want something
  //  different than the standard behavior of just updating the value within the object. (ex: saving
  //  automatically, popping up a modal first, etc).
  @Output() fileSelected: EventEmitter<any> = new EventEmitter();
  @Output() fileRemoved: EventEmitter<any> = new EventEmitter();
  @Input() displayNameOverride: string = undefined;

  public displayName: string = 'No file chosen';
  @ViewChild('fileInput') fileElement: ElementRef;

  public get inputMode(): typeof InputMode {
    return InputMode;
  }

  public ngOnInit(): void {
    this.setDisplayName(this.obj[this.prop]?.name);
    super.ngOnInit();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes.displayNameOverride)
      this.setDisplayName(changes.displayNameOverride.currentValue);
  }
    
  public selectFile(): void {
   // Emit the selected file details
    this.fileSelected.emit({
        file: this.fileElement.nativeElement.files[0],
        previousFile: this.obj[this.prop]
      });
      
    //  Check if the emitted output is being observed and act appropriately
    if (this.fileSelected.observed) {
      //  If we're overriding the select behavior and forcing the display name to remain blank, we'll want
      //  to clear the file selected as well.
      if ((this.displayNameOverride !== undefined) && (!this.displayNameOverride))
        this.fileElement.nativeElement.value = null;

    } else {
        this.obj[this.prop] = this.fileElement.nativeElement.files[0];
        this.validate();
        super.onChange();
        this.setDisplayName(this.obj[this.prop]?.name);
    }    
  }

  //  Mimics the file name shortening behavior seen in the standard file input.
  private setDisplayName(name: string): void {
    if (!name)
      this.displayName = 'No file chosen';

    else if (name.length <= 24)
      this.displayName = name;

    else {
        let start = name.substring(0, 11);
        let end = name.substring(name.length - 13);
      this.displayName = `${start}...${end}`;
    }
  }

  public removeFile(): void {
    this.fileRemoved.emit(this.obj[this.prop]);

    // Check if the Output is being subscribed to using the observed property.   
    if (!this.fileRemoved.observed) {
      this.obj[this.prop] = null;
      this.fileElement.nativeElement.value = null;
      this.setDisplayName('');
      super.onChange();
      this.validate();
    }    
  }

}
